import { render } from "./ForgotPasswordComponent.vue?vue&type=template&id=c969eafa&scoped=true"
import script from "./ForgotPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordComponent.vue?vue&type=script&lang=js"

import "./ForgotPasswordComponent.vue?vue&type=style&index=0&id=c969eafa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c969eafa"]])

export default __exports__